// Mirror of `SEED_PHRASEBOOK_SET` in `/app/backend/server.py`. Keep in
// sync — when a phrase appears here, the backend's /translate fast-path
// exempts it from the user's daily quota and caches the result
// PERMANENTLY across all users. Adding a new seed phrase requires
// updating both files.
//
// Used by TranslatePanel's client-side quota gate so users at their
// daily limit can still tap built-in phrasebook entries without seeing
// the paywall. Free-text translations still hit the paywall normally.

export const SEED_PHRASEBOOK_PHRASES = [
  "Hello!",
  "Thank you so much.",
  "Goodbye, have a nice day.",
  "Sorry, I don't speak the language very well.",
  "Do you speak English?",
  "A table for two, please.",
  "Could I see the menu?",
  "What do you recommend?",
  "I'll have this one, please.",
  "Is this spicy?",
  "I'm allergic to nuts.",
  "The check, please.",
  "Where is the restroom?",
  "Can I have water, no ice?",
  "Delicious, thank you!",
  "How much does this cost?",
  "Do you accept credit card?",
  "Is there a discount?",
  "Do you have this in a smaller size?",
  "Can I try it on?",
  "I'll take it.",
  "Just looking, thanks.",
  "Where is the nearest train station?",
  "How do I get to this address?",
  "Is it far from here?",
  "Can you show me on the map?",
  "Which way to the beach?",
  "Is this the right bus?",
  "I need help, please.",
  "Call the police.",
  "I lost my passport.",
  "I need a doctor.",
  "Where is the pharmacy?",
  "I don't feel well.",
];

const SEED_PHRASEBOOK_SET = new Set(
  SEED_PHRASEBOOK_PHRASES.map((p) => p.trim().toLowerCase())
);

/** Whether the given text is one of the bundled phrasebook phrases.
 * Case-insensitive + whitespace-tolerant so the frontend matches what
 * the backend matches (server.py: `_is_seed_phrase`). */
export function isSeedPhrase(text) {
  return SEED_PHRASEBOOK_SET.has((text || "").trim().toLowerCase());
}
